export interface ExtractedName {
  firstName: string;
  lastName: string;
}

export const extractUserNameSurname = (input: string): ExtractedName | null => {
  if (!input) return null;

  const original = input.trim();
  if (!original) return null;

  let cleaned = original.replace(/^["'<\s]+|[">\s]+$/g, '');

  if (cleaned.includes('@')) cleaned = cleaned.split('@')[0];

  cleaned = cleaned
    .replace(/[._+]+/g, ' ')
    .replace(/[^\p{L}\p{M}\s-]+/gu, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const parts = cleaned ? cleaned.split(' ').filter(Boolean) : [];

  const validSplit =
    parts.length >= 2 && parts.every((part) => part.length >= 2);

  const capitalise = (value: string) =>
    value
      ? value[0].toLocaleUpperCase() + value.slice(1).toLocaleLowerCase()
      : value;

  if (validSplit) {
    const [first, ...rest] = parts;
    return {
      firstName: capitalise(first),
      lastName: rest.map(capitalise).join(' '),
    };
  }

  return { firstName: original, lastName: '' };
};
